import seigyoMiddleware from '@/middlewares/seigyo';
import mcaRedirectorMiddleware from '@/middlewares/mcaRedirectorMiddleware';
import chatbotMiddleware from '@/middlewares/chatbotMiddleware';

export default (router) => {
  router.beforeEach((to, from, next) => {
    mcaRedirectorMiddleware(to, from, next);
    chatbotMiddleware(to, from, next);
    seigyoMiddleware(to, from, next);
    next();
  });
};
